import { Component, Input, OnInit } from '@angular/core';
import { DoctorAppointment } from 'src/app/entities/appointment.entity/doctor-appointment.entity/doctor-appointment';

@Component({
  selector: 'app-doctor-appointment-success',
  templateUrl: './doctor-appointment-success.component.html',
  styleUrls: ['./doctor-appointment-success.component.css']
})

export class DoctorAppointmentSuccessComponent implements OnInit {
  @Input() doctorAppointment!: DoctorAppointment;

  constructor() { }

  ngOnInit(): void {
  }

}
